import './theme/overrides.less';
import 'antd/dist/reset.css';

export { StyleProvider } from '@ant-design/cssinjs';
export type {
  FormInstance,
  FormItemProps,
  MenuItemProps,
  MenuProps,
  ModalFuncProps,
  ModalProps,
  RadioChangeEvent,
} from 'antd';
export {
  Affix,
  Alert,
  Anchor,
  AutoComplete,
  BackTop,
  Badge,
  Breadcrumb,
  Calendar,
  Carousel,
  Cascader,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  DatePicker,
  Descriptions,
  Divider,
  Drawer,
  Dropdown as DropdownBase,
  Empty,
  Flex,
  Form,
  InputNumber,
  Layout,
  List,
  Mentions,
  Menu,
  Modal,
  message,
  notification,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Rate,
  Row,
  Select,
  Skeleton,
  Slider,
  Spin,
  Statistic,
  Steps,
  Switch,
  Table,
  Tabs,
  Timeline,
  Transfer,
  Tree,
  TreeSelect,
  Upload,
} from 'antd';
export { default as en_GB } from 'antd/lib/locale/en_GB';
export { default as fr_FR } from 'antd/lib/locale/fr_FR';
export type { ColumnType } from 'antd/lib/table';
export type { RcFile } from 'antd/lib/upload';
export type { UploadFile } from 'antd/lib/upload/interface';
export { default as Avatar } from './components/Avatar';
export * from './components/BannerCard';
export { default as Button } from './components/Button';
export { default as Card } from './components/Card';
export { CardBase } from './components/CardBase';
export * from './components/Contact';
export * from './components/DetailCard';
export * from './components/Dropdown';
export { default as EmptyState } from './components/EmptyState';
export { default as Icon } from './components/Icon';
export * from './components/Input';
export { default as Logo } from './components/Logo';
export { default as MediumLogo } from './components/MediumLogo';
export { default as Page } from './components/Page';
export * from './components/SimplePagination';
export { default as Space } from './components/Space';
export * from './components/Spinner';
export * from './components/Tag';
export * from './components/TagFeedback';
export { default as TimePicker } from './components/TimePicker';
export { default as Typography } from './components/Typography';
export { default as VirtualTable } from './components/VirtualTable';
export { default as colors } from './theme/colors';
